import React, { useMemo } from "react";
import { useAuth } from "@/AuthContext";
import { CaretRight, TreeStructure, List } from "@phosphor-icons/react";
import { useStructureDetail, canUseStructures } from "@/hooks/useStructureDetail";

// Nombre de "organización": estructura activa, o empresa activa si no hay estructura
export function useOrgName() {
  const { structures, activeStructureId, companies, activeCompanyId, user } = useAuth();
  const s = (structures || []).find(x => x.id === activeStructureId);
  if (s) return s.name;
  const c = (companies || []).find(x => x.id === (activeCompanyId || user?.active_company_id || user?.company_id));
  return c?.name || "ZAE";
}

export default function HeaderContext({ onOpenPanel, onOpenSidebar }) {
  const { user, structures, activeStructureId, activeNodeId } = useAuth();
  const orgName = useOrgName();
  const detail = useStructureDetail(activeStructureId);
  const showStructure = canUseStructures(user, structures);
  const structure = (structures || []).find(s => s.id === activeStructureId);
  const nodeLabel = useMemo(
    () => (detail?.nodes || []).find(n => n.id === activeNodeId)?.label,
    [detail, activeNodeId]
  );

  return (
    <div className="flex items-center gap-3 min-w-0">
      <button onClick={onOpenSidebar} className="lg:hidden text-neutral-700" data-testid="sidebar-open-btn"><List size={22}/></button>
      <img src="/ZAE_ROJO.png" alt="ZAE Documental" className="h-8 w-auto object-contain shrink-0"/>
      <div className="hidden sm:block leading-tight min-w-0 max-w-[11rem]">
        <div className="font-display font-bold text-[15px] text-neutral-900 truncate" data-testid="header-org-name">{orgName}</div>
        <div className="text-[10px] font-bold tracking-[0.18em] text-blue-600">ZAE DOCUMENTAL</div>
      </div>
      {showStructure && (
        <>
          <span className="hidden md:block w-px h-8 bg-neutral-200 mx-2"/>
          <button onClick={onOpenPanel} data-testid="structure-navigator-trigger"
            className={`hidden md:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold border transition-colors duration-150 max-w-[18rem] ${structure ? "bg-blue-50 border-blue-200 text-blue-700 hover:border-blue-400" : "bg-white border-neutral-300 text-neutral-600 hover:border-neutral-400"}`}>
            <TreeStructure size={14} weight="duotone" className="shrink-0"/>
            <span className="truncate">{structure ? structure.name : "Navegar estructura"}</span>
          </button>
          {structure && (
            <button onClick={onOpenPanel} className="hidden md:flex items-center gap-2 min-w-0 text-neutral-800 hover:text-blue-700" data-testid="header-active-node">
              <CaretRight size={13} weight="bold" className="text-neutral-400 shrink-0"/>
              <span className="font-semibold text-[15px] truncate max-w-[16rem]">{nodeLabel || "Toda la estructura"}</span>
            </button>
          )}
        </>
      )}
    </div>
  );
}
